// extracted by mini-css-extract-plugin
export var blue = "_1i-h";
export var brand = "_1i-d";
export var darkGrey = "_1i-g";
export var disabled = "_1i-6";
export var disabledSubtle = "_1i-7";
export var error = "_1i-8";
export var green = "_1i-i";
export var grey = "_1i-f";
export var icon = "_1i-0";
export var inherit = "_1i-c";
export var lightGrey = "_1i-e";
export var orange = "_1i-k";
export var pink = "_1i-m";
export var primary = "_1i-1";
export var purple = "_1i-n";
export var quaternary = "_1i-4";
export var quinary = "_1i-5";
export var red = "_1i-l";
export var secondary = "_1i-2";
export var success = "_1i-b";
export var tertiary = "_1i-3";
export var warning = "_1i-9";
export var warningSecondary = "_1i-a";
export var white = "_1i-o";
export var yellow = "_1i-j";